export default __webpack_public_path__ + "static/media/swimming.051a5f61.jpg";